import React, { Component } from "react";
import { connect } from "react-redux";
import ConfirmAction from "MODULES/shared/components/ConfirmAction";
import { Map } from "immutable";
import { NoteTooltip } from "MODULES/shared/components/NoteTooltip";
import PropTypes from "prop-types";
import { shortDate } from "LIB/formatters/date";
import {
  DO_NOT_EXCHANGE,
  MANDATORY_ADDITIONAL_VERBIAGE,
  VENDOR_TRACE_PREAPPROVAL_REQUIRED,
  FAA_APPROVED,
  EASA_APPROVED,
  UK_CAA_APPROVED,
  TCCA_APPROVED,
  CAAC_APPROVED,
  OTHER_APPROVED,
  EXPORT_COMPLIANT,
  EXPORT_APPROVAL_REQUIRED,
  END_USER_AGREEMENT_REQUESTED
} from "MODULES/companies/constants";
import {
  WAREHOUSE,
  ROLES,
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES
} from "MODULES/users/constants";
import { without } from "lodash";
import { properCase } from "LIB/formatters/text";
import CheckForDetail from "MODULES/shared/components/DetailTable/CheckForDetail";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";
import Status from "./Status";
import ApprovalStatus from "./ApprovalStatus";
import DoNotQuote from "./DoNotQuote";
import PendingStatus from "./PendingStatus";
import VendorApproval from "./VendorApproval";
import * as actions from "../../actions";
import {
  Authorized,
  Detail,
  DetailTable,
  EditButton
} from "../../../shared/components";
import EditApprovals from "../EditApprovals";

class ApprovalsTable extends Component {
  state = {
    editApprovalsModalOpen: false,
    vendorConfirmModalOpen: false,
    stationConfirmModalOpen: false
  };

  toggleModalState = key => {
    const currentValue = this.state[key];
    this.setState({ [key]: !currentValue });
  };

  openVendorConfirmModal = () => {
    this.setState({ vendorConfirmModalOpen: true });
  };

  openStationConfirmModal = () => {
    this.setState({ stationConfirmModalOpen: true });
  };

  closeVendorConfirmModal = () =>
    this.setState({ vendorConfirmModalOpen: false });

  closeStationConfirmModal = () =>
    this.setState({ stationConfirmModalOpen: false });

  render() {
    const { editApprovalsModalOpen } = this.state;
    const { company } = this.props;
    const approvalText = (timestamp, approver) =>
      `Updated by ${approver.get("full_name")} on ${shortDate(timestamp)}`;

    return (
      <div>
        <h2 style={{ marginTop: 10 }}>
          Status & Approvals
          <Authorized
            permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
            roles={without(ROLES, WAREHOUSE)}
          >
            <EditButton
              handleClick={() =>
                this.toggleModalState("editApprovalsModalOpen")}
            />
            <EditApprovals
              company={company.toJS()}
              open={editApprovalsModalOpen}
              close={() => this.toggleModalState("editApprovalsModalOpen")}
            />
          </Authorized>
        </h2>
        <DetailTable>
          <Detail
            label="Status"
            value={
              <React.Fragment>
                <Status status={company.get("status")} />
                &nbsp;
                {company.get("updated_by") && (
                  <span className="text-right">
                    <NoteTooltip
                      placement="right"
                      icon="fa-info-circle"
                      color="rgba(255, 255, 255, 0.25)"
                      note={approvalText(
                        company.get("updated_at"),
                        company.get("updated_by")
                      )}
                    />
                  </span>
                )}
              </React.Fragment>
            }
          />
          <Detail
            label="Vendor"
            value={
              <React.Fragment>
                <VendorApproval
                  status={company.get("vendor_status")}
                  onApprovalRequest={() =>
                    this.toggleModalState("vendorConfirmModalOpen")}
                />
                &nbsp;
                {company.get("vendor_status_updated_by") && (
                  <span className="text-right">
                    <NoteTooltip
                      placement="right"
                      icon="fa-info-circle"
                      color="rgba(255, 255, 255, 0.25)"
                      note={approvalText(
                        company.get("vendor_status_updated_at"),
                        company.get("vendor_status_updated_by")
                      )}
                    />
                  </span>
                )}
              </React.Fragment>
            }
          />
          <Detail
            label="Repair Station"
            value={
              <React.Fragment>
                <VendorApproval
                  status={company.get("repair_station_status")}
                  onApprovalRequest={this.openStationConfirmModal}
                />
                &nbsp;
                {company.get("repair_station_status_updated_by") && (
                  <span className="text-right">
                    <NoteTooltip
                      placement="right"
                      icon="fa-info-circle"
                      color="rgba(255, 255, 255, 0.25)"
                      note={approvalText(
                        company.get("repair_station_status_updated_at"),
                        company.get("repair_station_status_updated_by")
                      )}
                    />
                  </span>
                )}
              </React.Fragment>
            }
          />
          <Detail
            label="Blanket Exch. Agreement"
            value={
              <React.Fragment>
                {company.get("blanket_exchange_agreement") &&
                  company.get("blanket_exchange_agreement_updated_by") && (
                    <React.Fragment>
                      <span className="text-success">
                        <i className="fa fa-check" /> Approved
                      </span>
                      &nbsp;
                      <span className="text-right">
                        <NoteTooltip
                          placement="right"
                          icon="fa-info-circle"
                          color="rgba(255, 255, 255, 0.25)"
                          note={approvalText(
                            company.get(
                              "blanket_exchange_agreement_updated_at"
                            ),
                            company.get("blanket_exchange_agreement_updated_by")
                          )}
                        />
                      </span>
                    </React.Fragment>
                  )}
              </React.Fragment>
            }
          />
          <Detail
            label="Export compliant"
            value={
              <React.Fragment>
                <PendingStatus
                  pending={
                    !company.get(EXPORT_COMPLIANT) &&
                    !company.get(EXPORT_APPROVAL_REQUIRED) &&
                    company.get(END_USER_AGREEMENT_REQUESTED)
                  }
                />
                &nbsp;
                <ApprovalStatus
                  approved={company.get(EXPORT_COMPLIANT)}
                  restricted={company.get(EXPORT_APPROVAL_REQUIRED)}
                />
                &nbsp;
                {company.get("export_compliant_updated_by") &&
                  !company.get(EXPORT_APPROVAL_REQUIRED) && (
                    <span className="text-right">
                      <NoteTooltip
                        placement="right"
                        icon="fa-info-circle"
                        color="rgba(255, 255, 255, 0.25)"
                        note={approvalText(
                          company.get("export_compliant_updated_at"),
                          company.get("export_compliant_updated_by")
                        )}
                      />
                    </span>
                  )}
              </React.Fragment>
            }
          />
          <Detail
            label="AC-0056B"
            value={
              <React.Fragment>
                <ApprovalStatus approved={company.get("asa_approved")} />
                &nbsp;
                <span className="text-right">
                  {company.get("asa_approved_updated_by") && (
                    <NoteTooltip
                      placement="right"
                      icon="fa-info-circle"
                      color="rgba(255, 255, 255, 0.25)"
                      note={approvalText(
                        company.get("asa_approved_updated_at"),
                        company.get("asa_approved_updated_by")
                      )}
                    />
                  )}
                </span>
              </React.Fragment>
            }
          />
          <Detail
            label="FAA"
            value={<ApprovalStatus approved={company.get(FAA_APPROVED)} />}
          />
          <Detail
            label="EASA"
            value={<ApprovalStatus approved={company.get(EASA_APPROVED)} />}
          />
          <Detail
            label="UK CAA"
            value={
              <div>
                <ApprovalStatus approved={company.get(UK_CAA_APPROVED)} />
                <AuditedNoteTooltip
                  obj={company.toJS()}
                  field={"uk_caa_approved"}
                />
              </div>
            }
          />
          <Detail
            label="CAAC"
            value={<ApprovalStatus approved={company.get(CAAC_APPROVED)} />}
          />
          <Detail
            label="TCCA"
            value={<ApprovalStatus approved={company.get(TCCA_APPROVED)} />}
          />
          <Detail
            label="Other"
            value={
              <div>
                <ApprovalStatus approved={company.get(OTHER_APPROVED)} />
                <AuditedNoteTooltip
                  obj={company.toJS()}
                  field={"other_approval"}
                  notePrefix={`${company.get("other_approval")} by `}
                />
              </div>
            }
          />
          <Detail
            label="Do Not Quote"
            value={<DoNotQuote doNotQuote={company.get("do_not_quote")} />}
          />
          <CheckForDetail
            className="text-danger"
            text={properCase(DO_NOT_EXCHANGE)}
            label={properCase(DO_NOT_EXCHANGE)}
            value={company.get(DO_NOT_EXCHANGE)}
          />
          <CheckForDetail
            className="text-danger"
            text="Approval Required"
            label="Vendor Trace Preapproval"
            value={company.get(VENDOR_TRACE_PREAPPROVAL_REQUIRED)}
          />
          <CheckForDetail
            value={company.get(MANDATORY_ADDITIONAL_VERBIAGE)}
            label="PO Mandatory Add'l Verbiage"
          />
        </DetailTable>
        <ConfirmAction
          onConfirm={this.props.requestVendorApproval}
          close={this.closeVendorConfirmModal}
          open={this.state.vendorConfirmModalOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to request&nbsp;
          <strong>vendor approval</strong>?
        </ConfirmAction>
        <ConfirmAction
          onConfirm={this.props.requestStationApproval}
          close={this.closeStationConfirmModal}
          open={this.state.stationConfirmModalOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to request&nbsp;
          <strong>repair station approval</strong>?
        </ConfirmAction>
      </div>
    );
  }
}

ApprovalsTable.propTypes = {
  company: PropTypes.instanceOf(Map),
  requestVendorApproval: PropTypes.func.isRequired,
  requestStationApproval: PropTypes.func.isRequired
};

export default connect(undefined, dispatch => ({
  requestVendorApproval: () =>
    dispatch(actions.update({ request_vendor_approval: true })),
  requestStationApproval: () =>
    dispatch(actions.update({ request_shop_approval: true }))
}))(ApprovalsTable);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/ApprovalsTable.jsx